/**
 * Runtime config. Two values that need to differ between local dev and a
 * production deployment behind a public domain:
 *
 *   1. `baseUrl`  — origin of the FastAPI server. In dev we proxy via Vite
 *      (relative paths). In a built bundle served by FastAPI itself the SPA
 *      lives under `/app/` on the same origin, so relative paths still work.
 *      Users can override (e.g. point a phone browser at a LAN dev server).
 *
 *   2. `apiKey`   — the public `X-API-Key` gate (see app/middleware/api_key.py).
 *      Mirrors `BuildConfig.TRANSLATOR_API_KEY` in the Android app. Persisted
 *      in `localStorage` so the user only enters it once.
 */
const LS_BASE = "tw.baseUrl";
const LS_KEY = "tw.apiKey";

export function getBaseUrl(): string {
  return localStorage.getItem(LS_BASE) ?? "";
}
export function setBaseUrl(v: string): void {
  if (v) localStorage.setItem(LS_BASE, v);
  else localStorage.removeItem(LS_BASE);
}
export function getApiKey(): string {
  return localStorage.getItem(LS_KEY) || (import.meta.env.VITE_API_KEY ?? "");
}
export function setApiKey(v: string): void {
  if (v) localStorage.setItem(LS_KEY, v);
  else localStorage.removeItem(LS_KEY);
}

/** Resolve a path against the configured base URL. Relative if empty. */
export function resolveHttp(path: string): string {
  const base = getBaseUrl().trim().replace(/\/$/, "");
  return base ? `${base}${path}` : path;
}

/** Resolve a WebSocket URL. Falls back to current origin in dev / same-origin host. */
export function resolveWs(path: string): string {
  const base = getBaseUrl().trim().replace(/\/$/, "");
  if (base) {
    const u = new URL(base);
    u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
    return u.toString().replace(/\/$/, "") + path;
  }
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}${path}`;
}
